module.exports = __webpack_public_path__ + "static/media/back.3aa043a0.svg";